import React from "react";
import { BankUserContextInterface } from "./models/BankUserContext";

const defaultState = {
  bankRolesData:null,
  bankuserDetails: null,
  updateClientDetails: ()=>{},
  clientId: null,
  updateClientId: () => {},
  complianceDashboardPage: false,
  updateComplainceDashboardPage: () => {},
  orgProductsList: [],
  selectedProduct: null,
  updateOrgProductsList: (token:string) => {},
  setSelectedProduct: () => {},
};

const BankUserContext =
  React.createContext<BankUserContextInterface>(defaultState);

export { BankUserContext };
